export * from './ColorDetailsPlaceholder';
export { default } from './ColorDetailsPlaceholder';